import type { User } from '../firebase/firebase';
import { PayrollIntegrationEmployee } from '../models/Integrations/PayrollIntegration';
import {
	defaultCloudFunctionServices,
	makeCloudFunctionRequest,
} from './BaseCloudFunctionRequests';
import { HTTPSCloudFunctionURLs } from './HTTPSCloudFunctionURLs';

export type PayrollIntegrationEmployeeResponse = {
	employees: PayrollIntegrationEmployee[];
};

export const fetchPayrollEmployeeIDs = async (
	abortSignal: AbortSignal,
	user: User,
): Promise<PayrollIntegrationEmployeeResponse> => {
	return await makeCloudFunctionRequest<PayrollIntegrationEmployeeResponse>({
		abortSignal,
		user,
		url: HTTPSCloudFunctionURLs.PayrollEmployeeIDs,
		method: 'GET',
		services: defaultCloudFunctionServices,
	});
};
